import hclust from './hclust';

export default Object.assign({},
    hclust
);


// WEBPACK FOOTER //
// ./src/parse/index.js